export default __webpack_public_path__ + "static/media/paper-recapture-icon.4352e2b4.svg";